/**
 * マスター・用語・画面（F5）の oRPC contract。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 横串マスター・画面・用語の一覧と詳細の読取 procedure の入出力を oRPC contract として定義する。
 * @graph-connects none
 */
import { ScreenDetailInputSchema, ScreenDetailOutputSchema, ScreenListInputSchema, ScreenListOutputSchema, } from '../elements/index.js';
import { MasterDetailInputSchema, MasterDetailOutputSchema, MasterListInputSchema, MasterListOutputSchema, } from '../spec-graph-element-masters.js';
import { TermDetailInputSchema, TermDetailOutputSchema, TermListInputSchema, TermListOutputSchema, } from '../spec-graph-element-terms.js';
import { base } from './common.js';
/**
 * 横串マスター・画面・用語の読取 procedure（`specGraph` に載る）。
 *
 * 一覧は型ごとに 1 本（アクター・ドメイン・動詞・単位）で、入出力は同じ形である。
 * 詳細はステージを含む全型を `getMasterDetail` の 1 本が受ける。
 * @graph-connects none
 */
export const mastersContract = {
    listActors: base.input(MasterListInputSchema).output(MasterListOutputSchema),
    listDomains: base.input(MasterListInputSchema).output(MasterListOutputSchema),
    listVerbs: base.input(MasterListInputSchema).output(MasterListOutputSchema),
    listUnits: base.input(MasterListInputSchema).output(MasterListOutputSchema),
    getMasterDetail: base.input(MasterDetailInputSchema).output(MasterDetailOutputSchema),
    listScreens: base.input(ScreenListInputSchema).output(ScreenListOutputSchema),
    getScreenDetail: base.input(ScreenDetailInputSchema).output(ScreenDetailOutputSchema),
    listTerms: base.input(TermListInputSchema).output(TermListOutputSchema),
    getTermDetail: base.input(TermDetailInputSchema).output(TermDetailOutputSchema),
};
//# sourceMappingURL=masters.js.map